import { Component, effect, input, signal } from '@angular/core';

@Component({
    selector: 'app-loading-text',
    standalone: true,
    templateUrl: './loading-text.component.html',
})
export class LoadingTextComponent {
    public messages = input<string[]>([]);
    public interval = input<number>(3000);

    private index = -1;

    public currentMessage = signal('');
    public animationClass = signal('animate__fadeInUp');

    constructor() {
        effect((onCleanup) => {
            const msgs = this.messages();
            const intervalTime = this.interval();

            if (!msgs?.length) return;

            this.pickNextMessage();

            let animationTimeout: ReturnType<typeof setTimeout> | null = null;
            const messageInterval = setInterval(() => {
                this.animationClass.set('animate__fadeOutUp');

                animationTimeout = setTimeout(() => {
                    this.pickNextMessage();
                    this.animationClass.set('animate__fadeInUp');
                }, 500);
            }, intervalTime);

            onCleanup(() => {
                clearInterval(messageInterval);
                if (animationTimeout) clearTimeout(animationTimeout);
            });
        });
    }

    private pickNextMessage(): void {
        const msgs = this.messages();
        if (!msgs.length) return;

        let nextIndex;
        do {
            nextIndex = Math.floor(Math.random() * msgs.length);
        } while (msgs.length > 1 && nextIndex === this.index);

        this.index = nextIndex;
        this.currentMessage.set(msgs[this.index]);
    }
}
